// src/features/document/mapStatusToVariant.ts
// Auto-generated by corebuilder. Edit freely.

/**
 * Maps DocumentStatus enum to a Badge variant.
 */
export function mapDocumentStatusToVariant(
  status: string,
): 'success' | 'warning' | 'error' | 'info' | 'secondary' {
  switch (status) {
    case 'DOCUMENT_STATUS_APPROVED':
    case 'DOCUMENT_STATUS_PUBLISHED':
      return 'success';
    case 'DOCUMENT_STATUS_IN_REVIEW':
    case 'DOCUMENT_STATUS_PENDING_APPROVAL':
    case 'DOCUMENT_STATUS_REVISION':
      return 'warning';
    case 'DOCUMENT_STATUS_WITHDRAWN':
      return 'error';
    case 'DOCUMENT_STATUS_OBSOLETE':
    case 'DOCUMENT_STATUS_ARCHIVED':
      return 'secondary';
    case 'DOCUMENT_STATUS_DRAFT':
    default:
      return 'info';
  }
}

/** Human-readable label for DocumentStatus enum. */
export function documentStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    DOCUMENT_STATUS_DRAFT: 'Draft',
    DOCUMENT_STATUS_IN_REVIEW: 'In Review',
    DOCUMENT_STATUS_PENDING_APPROVAL: 'Pending Approval',
    DOCUMENT_STATUS_APPROVED: 'Approved',
    DOCUMENT_STATUS_PUBLISHED: 'Published',
    DOCUMENT_STATUS_REVISION: 'Revision',
    DOCUMENT_STATUS_OBSOLETE: 'Obsolete',
    DOCUMENT_STATUS_ARCHIVED: 'Archived',
    DOCUMENT_STATUS_WITHDRAWN: 'Withdrawn',
  };
  return labels[status] ?? status;
}

/** Maps AcknowledgmentStatus to Badge variant. */
export function mapAcknowledgmentStatusToVariant(
  status: string,
): 'success' | 'warning' | 'error' | 'info' | 'secondary' {
  switch (status) {
    case 'ACKNOWLEDGMENT_STATUS_ACKNOWLEDGED':
      return 'success';
    case 'ACKNOWLEDGMENT_STATUS_PENDING':
      return 'warning';
    case 'ACKNOWLEDGMENT_STATUS_OVERDUE':
      return 'error';
    case 'ACKNOWLEDGMENT_STATUS_WAIVED':
      return 'secondary';
    default:
      return 'info';
  }
}

/** Human-readable label for AcknowledgmentStatus. */
export function acknowledgmentStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    ACKNOWLEDGMENT_STATUS_PENDING: 'Pending',
    ACKNOWLEDGMENT_STATUS_ACKNOWLEDGED: 'Acknowledged',
    ACKNOWLEDGMENT_STATUS_OVERDUE: 'Overdue',
    ACKNOWLEDGMENT_STATUS_WAIVED: 'Waived',
  };
  return labels[status] ?? status;
}

/** Maps DocumentAuditAction to Badge variant. */
export function mapAuditActionToVariant(
  action: string,
): 'success' | 'warning' | 'error' | 'info' | 'secondary' {
  switch (action) {
    case 'DOCUMENT_AUDIT_ACTION_CREATED':
    case 'DOCUMENT_AUDIT_ACTION_PUBLISHED':
    case 'DOCUMENT_AUDIT_ACTION_APPROVED':
    case 'DOCUMENT_AUDIT_ACTION_ACKNOWLEDGED':
      return 'success';
    case 'DOCUMENT_AUDIT_ACTION_STATUS_CHANGED':
    case 'DOCUMENT_AUDIT_ACTION_SUBMITTED_FOR_APPROVAL':
    case 'DOCUMENT_AUDIT_ACTION_VERSION_CREATED':
    case 'DOCUMENT_AUDIT_ACTION_OWNER_CHANGED':
    case 'DOCUMENT_AUDIT_ACTION_CATEGORY_CHANGED':
      return 'warning';
    case 'DOCUMENT_AUDIT_ACTION_REJECTED':
    case 'DOCUMENT_AUDIT_ACTION_DELETED':
      return 'error';
    case 'DOCUMENT_AUDIT_ACTION_ARCHIVED':
    case 'DOCUMENT_AUDIT_ACTION_RESTORED':
      return 'secondary';
    case 'DOCUMENT_AUDIT_ACTION_VIEWED':
    case 'DOCUMENT_AUDIT_ACTION_DOWNLOADED':
    default:
      return 'info';
  }
}

/** Human-readable label for DocumentAuditAction. */
export function auditActionLabel(action: string): string {
  const labels: Record<string, string> = {
    DOCUMENT_AUDIT_ACTION_CREATED: 'Created',
    DOCUMENT_AUDIT_ACTION_UPDATED: 'Updated',
    DOCUMENT_AUDIT_ACTION_STATUS_CHANGED: 'Status Changed',
    DOCUMENT_AUDIT_ACTION_VERSION_CREATED: 'Version Created',
    DOCUMENT_AUDIT_ACTION_SUBMITTED_FOR_APPROVAL: 'Submitted for Approval',
    DOCUMENT_AUDIT_ACTION_APPROVED: 'Approved',
    DOCUMENT_AUDIT_ACTION_REJECTED: 'Rejected',
    DOCUMENT_AUDIT_ACTION_PUBLISHED: 'Published',
    DOCUMENT_AUDIT_ACTION_ARCHIVED: 'Archived',
    DOCUMENT_AUDIT_ACTION_RESTORED: 'Restored',
    DOCUMENT_AUDIT_ACTION_DELETED: 'Deleted',
    DOCUMENT_AUDIT_ACTION_ACKNOWLEDGMENT_REQUESTED: 'Acknowledgment Requested',
    DOCUMENT_AUDIT_ACTION_ACKNOWLEDGED: 'Acknowledged',
    DOCUMENT_AUDIT_ACTION_OWNER_CHANGED: 'Owner Changed',
    DOCUMENT_AUDIT_ACTION_CATEGORY_CHANGED: 'Category Changed',
    DOCUMENT_AUDIT_ACTION_DOWNLOADED: 'Downloaded',
    DOCUMENT_AUDIT_ACTION_VIEWED: 'Viewed',
  };
  return labels[action] ?? action;
}
